import { hashHistory } from 'react-router';
import jack from 'jack-logs';
import signUp from './lib';
import { setAdminPasscode, setFirstTimeClockingIn } from '../config/actions';

export const signUpSetField = (field, value) => ({
  type: 'SIGN_UP_SET_FIELD',
  data: { field, value },
});

export const signUpSetPhone = data => ({
  type: 'SIGN_UP_SET_PHONE', data,
});

export const signUpClearField = field => ({
  type: 'SIGN_UP_SET_FIELD',
  data: { field, value: '' },
});

export const signUpValidForm = value => ({
  type: 'SIGN_UP_VALID_FORM',
  data: { value },
});

export const signUpWorking = value => ({
  type: 'SIGN_UP_WORKING',
  data: { value },
});

export const signUpShowToast = () => ({
  type: 'SIGN_UP_SET_TOAST',
  data: { value: true },
});

export const signUpDelToast = () => ({
  type: 'SIGN_UP_DEL_TOAST',
});

export const signUpClearState = () => ({
  type: 'SIGN_UP_CLEAR_STATE',
});

export const clear = () => signUpClearState();

export const signUpComplete = () => ({
  type: 'SIGN_UP_COMPLETE',
});

export const signUpCreateAccount = form => (dispatch) => {
  dispatch(signUpDelToast());
  dispatch(signUpWorking(true));

  return signUp(dispatch, form)
    .then(() => {
      dispatch(signUpComplete());
      hashHistory.push('/done');
    })
    .catch((err) => {
      jack.error(err);
      dispatch(signUpShowToast());
      dispatch(signUpWorking(false));
    });
};

export const signUpGotoTimeClock = () => (dispatch) => {
  dispatch(setAdminPasscode());
  dispatch(setFirstTimeClockingIn());

  hashHistory.push('/timeclock');
};



// WEBPACK FOOTER //
// ./src/store/signUp/actions.js